/**
 * @generated SignedSource<<63f8ff82f71455a5be7d76be9b723c1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextField_text$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldInput_text">;
  readonly " $fragmentType": "TranslatableTextField_text";
};
export type TranslatableTextField_text$key = {
  readonly " $data"?: TranslatableTextField_text$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextField_text">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranslatableTextField_text",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranslatableTextFieldInput_text"
    }
  ],
  "type": "Text",
  "abstractKey": null
};

(node as any).hash = "20efe50d2c5459f93deadc1d128db0ba";

export default node;
